<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">
        <p-toast key="toastmsg"></p-toast>
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Accounts Report<span class="badge">{{totalRecords}}</span></h4>
            </div>
            <div class="rightDiv">
                <button class="exportBTn" pTooltip="XLS" tooltipPosition="bottom" (click)="exportExcel()" label="Export" icon="pi pi-file-excel"> <span><img
                    src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                Export</button>
            </div>
        </div>  
        <div class="mainDivBody">
            <div class="date-filterDiv">
                <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby" optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                        class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                        class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="TO: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <button (click)="accountsReportList(lastTableLazyLoadEvent)" class="searchFilterBtn">
                        <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <button (click)="clear()" class="clearFilterBtn">
                        <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                        <span>Clear All</span>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table class="expandable" #dt [value]="accountsData" [autoLayout]="true" [paginator]="true" [rows]="10"
                        [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
                        (onLazyLoad)="accountsReportList($event)" [totalRecords]="totalRecords" [loading]="loading"
                        [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th pfrozencolumn="" class="p-element text-nowrap idTD" pSortableColumn="_id">
                                    <div class="p-d-flex p-jc-between p-ai-center"> Id <p-sortIcon
                                            field="_id"></p-sortIcon>
                                    </div>
                                </th>
                                <th pfrozencolumn="" class="p-element text-nowrap fullnameTD" pSortableColumn="fullName">
                                    <div class="p-d-flex p-jc-between p-ai-center"> FullName <p-sortIcon
                                            field="fullName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pfrozencolumn="" class="p-element text-nowrap totalAmountTD" pSortableColumn="totalAmount">
                                    <div class="p-d-flex p-jc-between p-ai-center"> Total Amount <p-sortIcon
                                            field="totalAmount"></p-sortIcon>
                                    </div>
                                </th>
                                <th pfrozencolumn="" class="p-element text-nowrap descriptionTD" pSortableColumn="description">
                                    <div class="p-d-flex p-jc-between p-ai-center"> Description <p-sortIcon field="description"></p-sortIcon>
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th class="idTD">
                                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, '_id', 'contains')" [value]="dt.filters['_id'] ? dt.filters['_id'].value : ''"/>
                                </th>
                                <th class="fullnameTD">
                                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'fullName', 'contains')" [value]="dt.filters['fullName'] ? dt.filters['fullName'].value : ''"/>
                                </th>
                                <th class="totalAmountTD">
                                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'totalAmount', 'contains')" [value]="dt.filters['totalAmount'] ? dt.filters['totalAmount'].value : ''"/>
                                </th>
                                <th class="descriptionTD">
                                    <input pInputText type="text" (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'description', 'contains')" [value]="dt.filters['description'] ? dt.filters['description'].value : ''"/>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-accounts>
                            <tr class="p-selectable-row">
                                <td pfrozencolumn="" class="p-element text-nowrap idTD">
                                    {{ accounts?._id }}
                                </td>
                                <td pfrozencolumn="" class="p-element text-nowrap fullnameTD">
                                    {{ accounts?.fullName }}
                                </td>
                                <td class="p-element text-nowrap totalAmountTD">
                                    {{ accounts?.totalAmount }}
                                </td>
                                <td class="p-element text-nowrap descriptionTD">
                                    {{ accounts?.description }}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>   
        </div>           
    </div>
</div>
